<script setup lang="ts">
  defineProps({
    order: { type: Object, required: true },
    payment: { type: Object, required: true },
    method: { type: Object, required: true },
  });
</script>
<template>
  <article class="bank-transfer">
    <header class="bank-transfer__header">
      <h2 class="bank-transfer__heading">{{ $t('Dane do przelewu') }}</h2>
    </header>
    <section class="bank-transfer__details">
      <dl class="bank-transfer__list">
        <div class="bank-transfer__item bank-transfer__item-name">
          <dt class="bank-transfer__term bank-transfer__term-name">{{ $t('Odbiorca') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-name">{{ method.props.account_name }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-account">
          <dt class="bank-transfer__term bank-transfer__term-account">{{ $t('Numer konta') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-account">{{ method.props.account_nr }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item--address">
          <dt class="bank-transfer__term bank-transfer__term--address">{{ $t('Adres') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details--address">{{ method.props.address }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-bank">
          <dt class="bank-transfer__term bank-transfer__term-bank">{{ $t('Bank') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-bank">{{ method.props.bank_name }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-id">
          <dt class="bank-transfer__term bank-transfer__term-id">{{ $t('Tytułem') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-id">{{ order.id }}</dd>
        </div>
        <div class="bank-transfer__item bank-transfer__item-total">
          <dt class="bank-transfer__term bank-transfer__term-total">{{ $t('Kwota przelewu') }}</dt>
          <dd class="bank-transfer__details bank-transfer__details-total">
            <SfMoney :code="order.currency_code" :decimals="order.currency_decimals" :value="order.total_gross" />
          </dd>
        </div>
      </dl>
    </section>
    <section class="bank-transfer__warning">
      <header class="bank-transfer__warning-header">
        <h3 class="bank-transfer__warning-heading">{{ $t('Uwaga!') }}</h3>
        <p class="bank-transfer__warning-text">{{ $t('Pamiętaj, aby prawidłowo wypełnić tytuł oraz kwotę zamówienia. Błędnie podany numer zamówienia lub kwota, mogą znacząco wydłużyć proces obsługi zamówienia.') }}</p>
      </header>
    </section>
  </article>
</template>
<style lang="scss">
  @use "$assets/mixins/media";

  .bank-transfer {
    display: flex;
    flex-direction: column;
    margin: 2rem 0;
    gap: 1rem;

    &__term {
      font-weight: var(--font-weight-bold);
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    &__warning {
      margin-top: 2rem;
    }

    &__warning-text {
      font-size: 0.875rem

    }

    &__warning-heading {
      font-size: 1rem;
    }
  }

  @include media.query(lg) {

    .bank-transfer {
      &__heading {
        font-size: 1.25rem;
      }

      &__warning {
        margin-top: 1rem;
      }
    }
  }
</style>
